<div class="iq-services text-center wow slideInUp" data-wow-duration="0.5s">
  <div class="iq-icon mb-4">
    <ng-content select="[cardImage]"></ng-content>
  </div>
  <ng-content select="[cardTitle]"></ng-content>
  <ng-content select="[cardContent]"></ng-content>
</div>
